export default __webpack_public_path__ + "static/media/premium3.11b160ba.webp";